import React from 'react';
import PropTypes from 'prop-types';

const Mail03 = ({color = 'currentColor', ...props}) => (
  <svg
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.93774 2.65449L8.50024 8.08035L15.5315 2.65449M6.54682 7.50134L1.93774 12.5197M15.0627 12.1086L10.4531 7.50134M2.87524 13.3346C1.83971 13.3346 1.00024 12.4513 1.00024 11.3616V3.64101C1.00024 2.55133 1.83971 1.66797 2.87524 1.66797H14.1252C15.1608 1.66797 16.0002 2.55133 16.0002 3.64101V11.3616C16.0002 12.4513 15.1608 13.3346 14.1252 13.3346H2.87524Z"
      stroke="#002D6B"
      strokeWidth={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Mail03.propTypes = {
  color: PropTypes.string,
};

export default Mail03;
